import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

  if (environment.production) {
  enableProdMode();
  
  // This overrides the global console.log function with an empty function
  window.console.log = () => {};
  window.console.debug = () => {}; // Optional: hides debug logs too
}